module.exports = __webpack_public_path__ + "img/settings_960.510b4470.png";